import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import logoSrc from '../../assets/logoLaCanaCouleur.png';
import posterSrc from '../../images/culture-de-cbd-poster.jpg';
import { scrollTop } from '../../utils/utils';
import videoSrc from '../../videos/culture-de-cbd.mp4';
import './hero-video.styles.scss';

const HeroVideo = () => (
  <section className="hero-video" aria-labelledby="hero-video-title">
    <video
      className="hero-video-media"
      src={videoSrc}
      poster={posterSrc}
      autoPlay
      muted
      loop
      playsInline
    />

    <div className="hero-video-content">
      <img className="hero-video-logo" src={logoSrc} alt="La Cana CBD Shop" />
      <h1 className="hero-video-title" id="hero-video-title">
        Lacana CBD
      </h1>
      <p className="hero-video-lead">
        Un chanvre cultivé en plein champ, récolté à la main et séché lentement.
      </p>
      <Link className="hero-video-cta" to="/shop" onClick={scrollTop}>
        Découvrir
        <span className="hero-video-arrow" aria-hidden="true">
          <BsArrowRight />
        </span>
      </Link>
    </div>
  </section>
);

export default HeroVideo;
